import styled from 'styled-components';
import { colors, radius } from '../../styles/tokens';

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.onSurfaceVariant};
  display: block;
`;

export const PresetsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;

  margin: 10px 0 20px;
`;

interface PresetCardProps {
  active: boolean;
}

export const PresetCard = styled.button<PresetCardProps>`
  text-align: left;
  padding: 12px 14px;

  background-color: ${({ active }) =>
    active ? colors.primaryContainer : colors.surfaceContainer};
  border: 1px solid ${({ active }) => (active ? colors.primary : 'transparent')};
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  transition: background-color 150ms, border-color 150ms;

  &:hover {
    border-color: ${colors.primary};
  }
`;

export const PresetCardTitle = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: ${colors.onSurface};
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 4px;
`;

export const PresetCardDescription = styled.span`
  display: block;
  font-size: 12px;
  color: ${colors.onSurfaceVariant};
`;

export const PermissionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  max-height: 380px;
  overflow-y: auto;

  margin-bottom: 8px;
  padding-right: 4px;
`;

export const CategorySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  padding-bottom: 6px;
  border-bottom: 1px solid ${colors.outlineVariant};
`;

export const CategoryLabel = styled.span`
  flex: 1;
  font-size: 11px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const CategoryCount = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
`;

export const PermissionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PermissionDescription = styled.span`
  flex: 1;
  font-size: 13px;
  color: ${colors.onSurface};
`;

export const SensitiveTag = styled.span`
  padding: 2px 8px;
  border-radius: ${radius.full};

  background-color: ${colors.tertiaryContainer};
  color: ${colors.onPrimary};
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;

  white-space: nowrap;
`;
